/* unplugin-vue-components disabled */import { render } from "./SdkInfos.vue?vue&type=template&id=496abc7d&scoped=true"
import script from "./SdkInfos.vue?vue&type=script&lang=js"
export * from "./SdkInfos.vue?vue&type=script&lang=js"

import "./SdkInfos.vue?vue&type=style&index=0&id=496abc7d&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496abc7d"]])

export default __exports__